module.exports = "<div class=\"info-container\">\n  <div class=\"wrapper\">\n    <div class=\"content-container\">\n      <router-outlet>\n      </router-outlet>\n    </div>\n    <app-footer></app-footer>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/info/info.component.html
// module id = ./src/app/landing/info/info.component.html
// module chunks = main